var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { get, getRawValue } from '../../utils/get';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { getRssFullURL } from '../utils';
import { RSS_ROUTE_TYPES, RSS_ROUTES } from '../consts';
import { siteIDs } from '../../adapters/utils';
import { getCurrentLanguage, getCurrentSeoLang, } from '../blog-post/calculated/getCurrentLanguage';
import { getMultilingualTags } from '../../renderer/get-multilingual-tags';
export var getPageUrl = function (item) {
    return get(item, 'category.canonicalUrl');
};
export var getImageDataLegacy = function (IDs, item) {
    var _a;
    var hasImage = getRawValue(item, 'category.mainImage.hasImage');
    return _a = {},
        _a[IDs.MAIN_IMAGE] = hasImage ? get(item, 'category.mainImage.url') : '',
        _a[IDs.IMAGE_HEIGHT] = hasImage ? get(item, 'category.mainImage.height') : '',
        _a[IDs.IMAGE_WIDTH] = hasImage ? get(item, 'category.mainImage.width') : '',
        _a;
};
export var getLegacyData = function (IDs, item) {
    var _a, _b;
    return __assign(__assign((_a = {}, _a[IDs.ID] = get(item, 'category.id'), _a[IDs.TITLE] = get(item, 'category.title') || get(item, 'category.label'), _a[IDs.DESCRIPTION] = get(item, 'category.description'), _a), getImageDataLegacy(IDs, item)), (_b = {}, _b[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.BLOG_CATEGORY, item, getPageUrl(item)), _b[IDs.PREV_PAGE_URL] = get(item, 'category.prevUrl'), _b[IDs.NEXT_PAGE_URL] = get(item, 'category.nextUrl'), _b[IDs.CURRENT_PAGE] = get(item, 'category.pagination.currentPage'), _b[IDs.TOTAL_PAGE_COUNT] = get(item, 'category.pagination.totalPages'), _b[IDs.BLOG_FEED_ROUTE] = get(item, 'category.blogFeedRoute') ||
        getRssFullURL({
            siteUrl: get(item, 'context.siteUrl'),
            rssRoute: RSS_ROUTES[RSS_ROUTE_TYPES.BLOG],
        }), _b[siteIDs.PREV] = get(item, 'category.prevUrl'), _b[siteIDs.NEXT] = get(item, 'category.nextUrl'), _b[siteIDs.CURRENT_PAGE_NUMBER] = get(item, 'category.pagination.currentPage'), _b[siteIDs.TOTAL_PAGE_COUNT] = get(item, 'category.pagination.totalPages'), _b));
};
export var getDynamicPatternsSchemaLegacy = function (item) {
    var translatedPages = getRawValue(item, 'category.translatedPages') || [];
    var hasTranslations = Boolean(translatedPages.length);
    var currentLanguageCode = getCurrentLanguage(item);
    var currentSeoLang = getCurrentSeoLang(item);
    var currentUrl = getPageUrl(item);
    if (!item || !hasTranslations) {
        return { tags: [] };
    }
    var siteUrl = get(item, 'context.siteUrl');
    var tags = getMultilingualTags(__spreadArray(__spreadArray([
        {
            url: currentUrl,
            langCode: currentLanguageCode,
            seoLang: currentSeoLang,
        }
    ], translatedPages, true), [
        { url: siteUrl, langCode: 'x-default' },
    ], false));
    return { tags: tags };
};
export var setFullUrlLegacy = function (item, url) {
    if (url === void 0) { url = ''; }
    item = JSON.parse(JSON.stringify(item));
    item.category.path = url;
    item.category.canonicalUrl = url;
    return item;
};
export var getFullUrlLegacy = function (item) { return getPageUrl(item); };
export var hasMultilingualLegacy = function (item) {
    return Array.isArray(getRawValue(item, 'category.translatedPages'));
};
